import { ConnectionStatus } from '@/features/integrations/catalog/enums';
import type { IntegrationConnection } from '@/features/integrations/connections/view-model/types';
import * as styles from './styles.css';

export function getStatusBorderClass(connection: Pick<IntegrationConnection, 'status'> | null): string {
  if (connection == null) {
    return styles.inactiveBorder;
  }
  switch (connection.status) {
    case ConnectionStatus.connected:
      return styles.connectedBorder;
    case ConnectionStatus.noRecentData:
    case ConnectionStatus.needsAttention:
      return styles.needsAttentionBorder;
    case ConnectionStatus.error:
    case ConnectionStatus.authenticationError:
    case ConnectionStatus.configurationError:
      return styles.errorBorder;
    default:
      return styles.inactiveBorder;
  }
}
